<template>
  <div class="ips-cloud__page_side">
    <div class="ips-cloud__side_title">
      <div>
        <span v-if="!isCollapse">系统菜单</span>
        <div class="pull-right fs-18 pointer" @click="toggleCollapse">
          <span class="mgr-15" v-show="isCollapse"><i class="fas fa-caret-square-right"></i></span>
          <span v-show="!isCollapse"><i class="fas fa-caret-square-left"></i></span>
        </div>
      </div>

    </div>
    <div class="ips-cloud__menus_wrapper" ref="menus">
      <el-menu
        :default-active="active"
        class="ips-cloud__menus"
        :router="router"
        :collapse="isCollapse"
        :unique-opened="true"
        @select="handleSelect"
        @open="handleOpen"
        @close="handleClose">
        <template v-for="menu in menus">
          <template v-if="menu.isDisplay !== 0">


            <!--  第一级菜单 BEGIN  -->
            <el-submenu :index="menu.id" :key="menu.id"
                        v-if="menu.children && menu.menuPermission && menu.menuPermission.length > 0">
              <template slot="title">
                <div class="ips-cloud__menus_item_container">
                  <i :class="menu.icon" class="ips-icon"></i>
                  <span slot="title" class="ips-cloud__menus_text">{{ menu.name }}</span>
                </div>
              </template>
              <el-menu-item-group>
                <template v-for="childMenu in menu.menuPermission">
                  <template v-if="childMenu.isDisplay !== 0">

                    <!--  第二级菜单 BEGIN  -->
                    <template
                      v-if="childMenu.children && childMenu.menuPermission && childMenu.menuPermission.length > 0">
                      <el-submenu :key="childMenu.id" :index="childMenu.id">
                        <template slot="title">
                          <div class="ips-cloud__menus_item_container">
                            <i :class="childMenu.icon" class="ips-icon"></i>
                            <span slot="title" class="ips-cloud__menus_text">{{ childMenu.name }}</span>
                          </div>
                        </template>
                        <el-menu-item-group>
                          <template v-for="grandsonMenu in childMenu.menuPermission">

                            <!--  第三级菜单 BEGIN  -->
                            <el-menu-item :index="grandsonMenu.id" :key="grandsonMenu.id"
                                          :route="{path:grandsonMenu.url}" v-if="grandsonMenu.isDisplay !== 0">
                              <div class="ips-cloud__menus_item_container">
                                <i :class="grandsonMenu.icon" class="ips-icon"></i>
                                <span slot="title" class="ips-cloud__menus_text">{{ grandsonMenu.name }}</span>
                              </div>
                            </el-menu-item>
                            <!--  第三级菜单 END  -->

                          </template>
                        </el-menu-item-group>
                      </el-submenu>
                    </template>
                    <template v-else>
                      <el-menu-item :key="childMenu.id" :index="childMenu.id" :route="{path:childMenu.url}"
                                    v-if="childMenu.isDisplay !== 0">
                        <div class="ips-cloud__menus_item_container">
                          <i :class="childMenu.icon" class="ips-icon"></i>
                          <span slot="title"
                                class="ips-cloud__menus_text">{{ childMenu.name }}</span>
                        </div>
                      </el-menu-item>
                    </template>
                    <!--  第二级菜单 END  -->


                  </template>
                </template>
              </el-menu-item-group>
            </el-submenu>

            <template v-else>
              <el-menu-item :key="menu.id" :index="menu.id" :route="{path:menu.url}" v-if="menu.isDisplay !== 0">
                <div class="ips-cloud__menus_item_container">
                  <i :class="menu.icon" class="ips-icon"></i>
                  <span slot="title" class="ips-cloud__menus_text">{{ menu.name }}</span>
                </div>
              </el-menu-item>
            </template>
            <!--  第一级菜单 END  -->
          </template>
        </template>
      </el-menu>
    </div>
  </div>

</template>

<script>
import {utils} from '../components'
import BScroll from 'better-scroll'
import {APP_CATEGORY, SCROLL_CONFIG} from "../store/constant";
import URI from 'URI'
import {mapState} from "vuex";

export default {
  name: "PageSide"
  , props: {
    menus: {type: Array}
    , active: {type: [Number, String]}
    , router: {
      type: Boolean
      , default: false
    }
  }
  , computed: {
    ...mapState("app", ["currentUser"])
  }
  , data() {
    return {
      isCollapse: false
    }
  }
  , methods: {
    handleOpen() {
    }
    , handleClose() {
    }
    , handleSelect(index) {

      let menu = utils.exitInMenus(this.menus, {id: index});
      // console.log(this.menus);
      // console.log(menu);
      if (menu.isMark === APP_CATEGORY.REDIRECT) {
        let url = ""
        if (menu.url.includes('justbon')) {
          let token = this.$cookie.get("token");
          let userId = this.currentUser.id
          url = URI(menu.url).search({token, "access_token": token, userId}).toString()
        } else {
          url = menu.url
        }
        window.open(url)
      } else {
        this.$emit('selected', menu)
      }
    }
    // 是否开启折叠
    , toggleCollapse() {
      this.isCollapse = !this.isCollapse;
      this.$emit('collapse', this.isCollapse)
    }
  }
  , mounted() {

    new BScroll(this.$refs.menus, SCROLL_CONFIG)

  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/page_side.scss";
</style>
